// Cắt ca cho office mode (AntMainHeader). Dùng AntShiftActionOverlay (PIN-first lookup).
import React, { useCallback, useMemo, useState } from 'react';
import Button from 'devextreme-react/button';
import { RiCalendarCloseFill } from 'react-icons/ri';

import AntLocalization from '../../../utils/AntLocalization';
import AntAuth from '../../../utils/AntAuth.js';
import AntShiftActionOverlay from '../../AntShiftActionOverlay';
import './index.scss';

export default function () {
    const [popupVisible, setPopupVisible] = useState(false);
    const employeeCode = AntAuth.getSessionInfo('employee_code');

    const session = useMemo(
        () => ({
            employee_code: AntAuth.getSessionInfo('employee_code'),
            employee_name: AntAuth.getSessionInfo('employee_name'),
            employee_session_status: AntAuth.getSessionInfo('employee_session_status'),
            shift_id: AntAuth.getSessionInfo('shift_id'),
            store_name: AntAuth.getSessionInfo('store_name'),
            store_code: AntAuth.getSessionInfo('store_code')
        }),
        [popupVisible]
    );

    const onShowPopupClick = useCallback(() => setPopupVisible(true), []);
    const onClose = useCallback(() => setPopupVisible(false), []);
    const onDone = useCallback(() => {
        setPopupVisible(false);
        try { window.location.reload(); } catch (e) { /* ignore */ }
    }, []);

    if (!employeeCode) return null;

    return (
        <div>
            <Button
                id={'switchEmployeeShift'}
                className={'ant-employee-shift-checkout-button'}
                width={'auto'}
                height={'100%'}
                stylingMode={'text'}
                onClick={onShowPopupClick}
            >
                <div className={'ant-employee-shift-checkout-panel'}>
                    <div className={'ant-employee-shift-checkout'}>
                        <RiCalendarCloseFill className={'ant-employee-shift-checkout-image'} />
                        <div className={'ant-employee-shift-checkout-name'}>
                            {AntLocalization.translateText({ vi: 'Cắt ca', en: 'End Shift', fr: 'Fin de poste', es: 'Cerrar turno', id: 'Tutup shift', ja: 'シフト終了', zh: '结束班次', ko: '근무 종료', hi: 'शिफ्ट समाप्त', ar: 'إنهاء الوردية' })}
                        </div>
                    </div>
                </div>
            </Button>
            {popupVisible && (
                <AntShiftActionOverlay mode="checkout" session={session} onDone={onDone} onClose={onClose} />
            )}
        </div>
    );
}
